export const BUILDING_STATUS = {
    '热门楼盘': '热门楼盘',
    '即将预售': '即将取证',
    '最新取证': '最新开盘',
    '最新摇号': '最新摇号',
    '摇号剩余': '摇号剩余',
    '在售': '在售',
    '在售楼盘': '在售'
}

export const SHARE_PARAM_KEYS = [
    'wx_scene_id',
    'share_info',
    'device_info'
]

export const SHOW_CALL_TIP = true

export const CONSULATANT_CARD_IS_CALL = false

export const LEVEL_MAP = {
    gold: '金牌',
    silver: '银牌',
    copper: '铜牌'
}

export const MEDAL_TYPE = {
    ROOKIE: '超凡新星',
    GREAT: '超神',
    PHONE: '来电秒接',
    MSG: '在线秒回',
    EXPERT: '行业资深',
    LEARNED: '楼市百晓生'
}

export const CUSTOMER_SOURCE_TYPES = {
    TIM: 'tim',
    CALL: 'call'
}
export const CUSTOMER_SOURCE_MAP = {
    [CUSTOMER_SOURCE_TYPES.TIM]: '微聊咨询',
    [CUSTOMER_SOURCE_TYPES.CALL]: '电话咨询'
}

export const CUSTOMER_SOURCES = [
    {
        value: CUSTOMER_SOURCE_TYPES.TIM,
        name: CUSTOMER_SOURCE_MAP[CUSTOMER_SOURCE_TYPES.TIM]
    },
    {
        value: CUSTOMER_SOURCE_TYPES.CALL,
        name: CUSTOMER_SOURCE_MAP[CUSTOMER_SOURCE_TYPES.CALL]
    }
]

export const CUSTOMER_MARKS = [
    '意向客户',
    '潜在客户',
    '到访客户',
    '登记客户',
    '成交客户',
    '无效客户'
]

export const BUILDING_RANK_MAP = {
    comments: '热评榜',
    views: '人气榜',
    follows: '关注榜'
}

export const C_MP_SERVICE = {
    link: 'https://mp.weixin.qq.com/s/E9xhe0v_nd_B7p5Kc2GPew',
    name: '成都购房者之家'
}
export const PREVIEW_CATE_ORDER = ['样板间', '户型图', 'vr看房', '看航拍', '看总平', '周边配套', '看日照', '户型VR']
